// Titres « texte + $LaTeX$ » (titre de carte, d'exercice) : découpe pure, sans
// dépendance de rendu. Le rendu KaTeX est fait par `MathText` (@jeraisonne/ui).
//
// Règles (mêmes que l'inline de MarkdownMath) : `$…$` sur une seule ligne, non
// vide ; `\$` est un dollar littéral ; un `$` resté seul n'est PAS des maths
// (il reste du texte, et `hasUnbalancedMath` le signale avant publication).

export type MathTextPart = { kind: 'text'; value: string } | { kind: 'math'; value: string };

export function splitMathText(input: string): MathTextPart[] {
  const parts: MathTextPart[] = [];
  let text = '';
  let i = 0;
  const pushText = () => {
    if (text) parts.push({ kind: 'text', value: text });
    text = '';
  };
  while (i < input.length) {
    const ch = input[i];
    if (ch === '\\' && input[i + 1] === '$') {
      text += '$';
      i += 2;
      continue;
    }
    if (ch === '$') {
      // Fin de la formule : prochain `$` non échappé, sur la même ligne.
      let j = i + 1;
      while (j < input.length && input[j] !== '\n') {
        if (input[j] === '\\') {
          j += 2;
          continue;
        }
        if (input[j] === '$') break;
        j += 1;
      }
      const inner = j < input.length && input[j] === '$' ? input.slice(i + 1, j) : null;
      if (inner !== null && inner.trim()) {
        pushText();
        parts.push({ kind: 'math', value: inner.trim() });
        i = j + 1;
        continue;
      }
    }
    text += ch;
    i += 1;
  }
  pushText();
  return parts;
}

/** Version texte (aria-label, <title>, <option>) : les délimiteurs `$` retirés. */
export function stripMath(input: string): string {
  return splitMathText(input)
    .map((p) => p.value)
    .join('')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Un `$` non échappé qui n'ouvre ni ne ferme une formule = titre à corriger. */
export function hasUnbalancedMath(input: string): boolean {
  // `\$` (dollar littéral) est retiré AVANT la découpe : seuls restent les `$` actifs.
  return splitMathText(input.replace(/\\\$/g, '')).some(
    (p) => p.kind === 'text' && p.value.includes('$'),
  );
}
